// Age formatting. The dashboard says "last seen 23m ago" in several places and
// all of them should agree.

export function msSince(iso, now = Date.now()) {
  if (!iso) return null;
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return null;
  return now - t;
}

export function formatAge(ms) {
  if (ms == null) return 'never';
  if (ms < 0) return 'just now';
  const secs = Math.floor(ms / 1000);
  if (secs < 45) return `${secs}s ago`;
  const mins = Math.round(secs / 60);
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  const rem = mins % 60;
  if (hours < 24) return rem ? `${hours}h ${rem}m ago` : `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}

export function ageLabel(iso, now = Date.now()) {
  return formatAge(msSince(iso, now));
}

export function formatClock(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
}

export function formatDayClock(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const today = new Date();
  const sameDay = d.toDateString() === today.toDateString();
  return sameDay
    ? formatClock(iso)
    : `${d.toLocaleDateString([], { month: 'short', day: 'numeric' })} ${formatClock(iso)}`;
}

export function formatDuration(seconds) {
  if (seconds == null) return '';
  const s = Math.max(0, Math.round(seconds));
  if (s < 60) return `${s}s`;
  const mins = Math.round(s / 60);
  if (mins < 60) return `${mins} min`;
  const hours = Math.floor(mins / 60);
  const rem = mins % 60;
  return rem ? `${hours}h ${rem}m` : `${hours}h`;
}

/**
 * Metres as a labelled distance, in the tenant's unit (`org.distance_unit`,
 * miles by default). One decimal under ten miles or so and none above it: the
 * tenths matter while a truck is minutes out and are noise at 200 miles.
 *
 * `unit` is threaded from the caller rather than read from the store here,
 * because this file is pure and the board's tests drive it directly.
 */
export function formatMiles(meters, unit = 'mi') {
  if (meters == null) return '';
  if (unit === 'km') {
    const km = meters / 1000;
    return `${km.toFixed(meters < 16093 ? 1 : 0)} km`;
  }
  return `${(meters / 1609.344).toFixed(meters < 16093 ? 1 : 0)} mi`;
}

export function formatMph(mps, unit = 'mi') {
  if (mps == null) return '';
  if (unit === 'km') return `${Math.round(mps * 3.6)} km/h`;
  return `${Math.round(mps * 2.236936)} mph`;
}
